import React, { useContext, useEffect } from 'react';
import { ContentBox, Item } from '../ContentBox/ContentBox';
import { useGetLoanDocByLoan } from 'services/loan/querys';
import { TaskOpenModalContext } from 'scenes/Private/Private';
import { TaskState } from 'gql/graphql';
import { LoanTypes } from 'services/loan/type.constansts';

interface IProps {
  loanSelected: any;
  anotherDocs: any;
  tasks: any;
}

export const BoxAdditionalDocuments: React.FC<IProps> = ({ loanSelected, anotherDocs, tasks }: IProps) => {

  const { setHandler: openTask }: any = useContext(TaskOpenModalContext);
  const { data: loanDocs, reexecute: getLoanDocByLoan } = useGetLoanDocByLoan({ 
    variables: { loanId: loanSelected._id },
    pause: true
  });

  useEffect(() => {
    if(loanDocs?.length === 0) 
      getLoanDocByLoan({ requestPolicy: 'network-only' });
  }, []);

  const isInsuranceDocState = loanDocs?.find(item => item.key === 'insurance')
  let insuranceState = isInsuranceDocState? 'Contacted': 'Not Contacted';

  const taskTitle = tasks.find((item: any) => item.key === 'title_company');
  const openTaskTitle = (taskTitle?.state === TaskState.Review &&
    !taskTitle?.metadata?.titleCompany ? false : true);
  const isTitleDocState = loanDocs?.find(item => item.key === 'title')
  //Download
  const isDisabledInsurance = isInsuranceDocState && ((isInsuranceDocState?.state as any) !== TaskState.Approved);
  const isApprovedInsurance = (isInsuranceDocState?.state as any) === TaskState.Approved;
  if (isApprovedInsurance) insuranceState = '';

  const actionInsurance = () => {
    if(isApprovedInsurance && isInsuranceDocState?.file) {
      window.open(isInsuranceDocState?.file?.url, '_blank');
      return;
    }

    if(!isDisabledInsurance){
      openTask('insurance');
      return;
    }
  }

  const additionalDocumentsContent: Item[] = [
    ...(loanSelected?.type !== LoanTypes.RENTAL ?
      [{ field: 'Construction Budget', value: <span onClick={() => openTask('construction')}>{"View task ->"}</span> }]
      :
      []
    ),
    ...(loanSelected?.purpose === 'Purchase' ?
      [{ field: 'Purchase contract', value: <span onClick={() => openTask('purchase')}>{"View task ->"}</span> }]
      :
      []
    ),
    ...(loanSelected?.purpose === "Refinance" ?
      [{ field: 'Payoff letter', value: <span onClick={() => openTask('payoff')}>{"View task ->"}</span> }]
      :
      []
    ),
    {
      field: `Insurance`,
      state: insuranceState,
      value:
        <span
          aria-disabled={isDisabledInsurance}
          className={isDisabledInsurance ? 'disabled' : ''}
          style={{ opacity: isDisabledInsurance? 0.3: 1 }}
          onClick={actionInsurance}>
          {isApprovedInsurance? "Download ->": "View terms ->"}
        </span>
    },
    { field: 'Title', value: !isTitleDocState && openTaskTitle ? <span onClick={() => openTask('title_company')}>{"Not requested ->"}</span> :
    !isTitleDocState && !openTaskTitle ? <span>{"Not requested ->"}</span> :
    isTitleDocState && isTitleDocState?.state !== 'CLEARED' ? <span style={{ opacity: isTitleDocState?.hidden ? 0.3 : 1}} className={isTitleDocState.hidden ? 'disabled' : ''}> {"Requested ->"}</span> :
    <span
      className={isTitleDocState?.hidden ? 'disabled' : ''}
      onClick={() => !isTitleDocState?.hidden ? window.open(isTitleDocState?.file?.url, '_blank'): null}
      style={{ opacity: isTitleDocState?.hidden ? 0.3 : 1 }}
    >
      {"Download ->"}
    </span> },
  ];

  if (anotherDocs) {
    for (const anotherDoc of anotherDocs) {
      const file = anotherDoc.files[0];

      additionalDocumentsContent.push({
        field: anotherDoc.label,
        value: <span onClick={() => window.open(file.url, '_blank')}>{"View file ->"}</span>
      });
    }
  }

  return (
    <ContentBox
      label={'Additional documents'}
      content={additionalDocumentsContent}
    />
  );
}